module.exports=function(e){var i=String(e).split("."),n=i[0],r=!i[1],s=n.slice(-1),t=n.slice(-2);return r&&1==s&&11!=t?"one":r&&2<=s&&s<=4&&(t<12||14<t)?"few":r&&0==s||r&&5<=s&&s<=9||r&&11<=t&&t<=14?"many":"other"}


//////////////////
// WEBPACK FOOTER
// ./node_modules/relative-time-format/locale/ru/quantify.js
// module id = 687
// module chunks = 0